import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { GeneralService } from './general.service';
import { catchError, Observable, of, take } from 'rxjs';
import { AuthResponse } from '../models/auth-model/auth.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public URL_API = environment.apiURLNew;
  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {}

  public login(body: { u: string; p: string; v: number }): Observable<AuthResponse | null> {
    return this.http.post<AuthResponse>(this.URL_API + `/api/Account/Login`, body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  // public refreshToken(body: {
  //   token: string;
  //   refreshToken: string;
  //   origin: string;
  // }): Observable<AuthResponse | null> {
  //   return this.http.post<AuthResponse>(this.URL_API + `/refresh`, body).pipe(
  //     take(1),
  //     catchError(() => {
  //       return of(null);
  //     }),
  //   );
  // }

  public logout() {
    localStorage.clear();
    window.dispatchEvent(new CustomEvent('user-logout'));
    this.generalService.goToUrl(['/login'], {});
  }
}
